import React from 'react';

import { H3 } from '../../../styles/shared/typography';
import * as s from './styles';
import SafetyList from './SafetyList';

import IndicationCopy from './copy/safety-panel/indication';
import {safetyWeliregCopy ,safetyKeytrudaQlexCopy} from './copy/safety-panel/safety';
import { validateStringOrFunction } from '../../../util/general';

function MultiBrandIndicationAndSafetyPage({pageKey}) {
  const safetyWelireg = safetyWeliregCopy[pageKey] || safetyWeliregCopy.mt;
  return (
    <s.MultiBrandSafetyPageContainer narrow btmFlat>
      <section>
        <s.MultiBrandHeadingHThree multiBrandGrey className='indication-heading'>{ validateStringOrFunction(IndicationCopy[pageKey]?.indicationtitle || IndicationCopy.mt.indicationtitle)}</s.MultiBrandHeadingHThree>
        <s.MultiBrandIsiBody>
  {validateStringOrFunction(
    IndicationCopy[pageKey]?.indicationBody || IndicationCopy.indicationBody
  )}
</s.MultiBrandIsiBody>
        {
            IndicationCopy[pageKey] ? <>
            <s.MultiBrandHeadingHThree>
            { validateStringOrFunction(IndicationCopy[pageKey].title) }
          </s.MultiBrandHeadingHThree>
          <s.MultiBrandIsiBody>
            <p>{ validateStringOrFunction(IndicationCopy[pageKey].body) }</p>
          </s.MultiBrandIsiBody>
            </> : null
        }
      </section>

      <s.MultiBrandTwoIndicationSection id="safety-scroll-target">
        <div>
            <s.MultiBrandHeadingHThree multiBrandGrey><span className='blue-highlight'>{ validateStringOrFunction(safetyWelireg.title) }</span></s.MultiBrandHeadingHThree>
            <div>
            <SafetyList dataList={safetyWelireg} className='blue-container' />
            </div>
        </div>
        <div>
            <s.MultiBrandHeadingHThree>{ validateStringOrFunction(safetyKeytrudaQlexCopy.title) }</s.MultiBrandHeadingHThree>
            <div>
            <SafetyList dataList={safetyKeytrudaQlexCopy}  className='green-container' />
            </div>
        </div>
      </s.MultiBrandTwoIndicationSection>
    </s.MultiBrandSafetyPageContainer>
  );
}


export default MultiBrandIndicationAndSafetyPage;
